import { fechaComoTexto, formatearIntervalo } from "src/utils/fechas";
import { CabeceraFechaProps } from "src/utils/interfaces";

const CabeceraFechaHistorial: React.FC<CabeceraFechaProps> = (
  props: CabeceraFechaProps
) => {
  const duracion = `(${formatearIntervalo(props.tiempoTrabajado)})`;

  const textoDeCabecera = `${fechaComoTexto(props.fecha)} ${duracion}`;

  return <hr className="with-text" data-props={textoDeCabecera} />;
};

export default CabeceraFechaHistorial;
